module.exports = __webpack_public_path__ + "img/DWAYA_GIF_WEBSITE.gif";